export default class Member {
  public name: string

  constructor (name: string) {
    this.name = name
  }
}
